import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
 
import { Stand } from '../entity/Stand';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
 


@Injectable()
export class StandService {

  private baseUrl = environment.restApi;
  private standUrl = `${this.baseUrl}stand`;

  constructor(private http: HttpClient ) { }



  findStandsByProject(projectId: number, shwoAssigned: boolean): Observable<any> {
    //console.log(`Request ${this.standUrl}/${projectId}/${shwoAssigned}`);
    
    return this.http.get<Stand[]>(`${this.standUrl}/findStandsByProject/${projectId}/${shwoAssigned}`)
  }








  /**
      * Prepare an error handler for failed HTTP requests.
      * That handler extracts the error message and logs it.
      * It also adds the message to the errors$ observable to which the caller
      * may listen and react.
      * @param operation The name/description of the operation that failed
      * @param method The HTTP method for the failed HTTP request
      */
  protected handleError(operation: string, method: string) {
    return function errorHandler(res: HttpErrorResponse) {
      this.logger.error(res);
      const eMsg = res.message || '';
      const error = `${this.entityNamePlural} ${operation} Error${
        eMsg ? ': ' + eMsg : ''
        }`;
      this.notify(error, method);
    }.bind(this);
  }

  protected notify(message: string, method: string) {
   
  }

}
